// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IUmbrella https://sepolia.basescan.org/address/0x5AC6C5C70934939d7Ad4aAB253aFD760Ad5E5313
export const UMBRELLA = '0x5AC6C5C70934939d7Ad4aAB253aFD760Ad5E5313';

// https://sepolia.basescan.org/address/0x9d6A79103e4B8fA392551aC7F1bcAf6117A8ED5A
export const UMBRELLA_IMPL = '0x9d6A79103e4B8fA392551aC7F1bcAf6117A8ED5A';

// https://sepolia.basescan.org/address/0x07687e3F16540d6531a006Bf026e3a4862d6f996
export const UMBRELLA_STAKE_TOKEN_IMPL = '0x07687e3F16540d6531a006Bf026e3a4862d6f996';

// https://sepolia.basescan.org/address/0x412f8957f9A42FFe47B634AB73f89Ff4E0a29026
export const UMBRELLA_REWARDS_CONTROLLER = '0x412f8957f9A42FFe47B634AB73f89Ff4E0a29026';

// https://sepolia.basescan.org/address/0x811A6C5F91F39c128a969c6D6FA2494748DEAeBf
export const UMBRELLA_REWARDS_CONTROLLER_IMPL = '0x811A6C5F91F39c128a969c6D6FA2494748DEAeBf';

// https://sepolia.basescan.org/address/0x9F9c7F84C043Fe3366E8567352FB6ab352222b7d
export const PERMISSIONED_PAYLOADS_CONTROLLER = '0x9F9c7F84C043Fe3366E8567352FB6ab352222b7d';

// https://sepolia.basescan.org/address/0x228B2Fe0b214862D2A8129ecd983D1D872cEb95a
export const PERMISSIONED_PAYLOADS_CONTROLLER_EXECUTOR =
  '0x228B2Fe0b214862D2A8129ecd983D1D872cEb95a';

// https://sepolia.basescan.org/address/0xcDfb3f2d924b02A78a51F43BC34610dC62ADCEC3
export const UMBRELLA_BATCH_HELPER = '0xcDfb3f2d924b02A78a51F43BC34610dC62ADCEC3';

// https://sepolia.basescan.org/address/0x139FAF11d09605d840cBd1b1FBE4Adf5FEac70a2
export const DATA_AGGREGATION_HELPER = '0x139FAF11d09605d840cBd1b1FBE4Adf5FEac70a2';

export const CHAIN_ID = 84532;
export const UMBRELLA_STAKE_ASSETS = {
  STK_WA_USDC_V1: {
    STAKE_TOKEN: '0xD15e98f7AD53954fc96A7904738Eb1Ed1f6F0422',
    UNDERLYING: '0xf430cb6E2b85f99222fBFA6dFEa18Ff60FA6B32a',
    decimals: 6,
  },
  STK_WA_USDT_V1: {
    STAKE_TOKEN: '0x9287a4e4DDb8715862D5c94E6f3108E1E9A83321',
    UNDERLYING: '0xf63dA51069FAe9448747FA425F8Cb84B0149eC0F',
    decimals: 6,
  },
  STK_WA_WBTC_V1: {
    STAKE_TOKEN: '0xf9a03b111e22180172F5DF879ac3c5d19BA75975',
    UNDERLYING: '0x5d7538579560F5fdD54F9D264DBe0e697b5BF668',
    decimals: 8,
  },
  STK_WA_cbETH_V1: {
    STAKE_TOKEN: '0x36edA587e02e897Db071000ac37606B2767d68aa',
    UNDERLYING: '0x9F56ff6c3441bb89eBFf1c0bc75D4096C33230d1',
    decimals: 18,
  },
  STK_WA_LINK_V1: {
    STAKE_TOKEN: '0x16C2230c3B1116Acdf3dE7202893cb5f0fBde6E6',
    UNDERLYING: '0xFb3AB5ABd3dE4703C0F296B1fe6f5E570e1631Ff',
    decimals: 18,
  },
  STK_WETH_V1: {
    STAKE_TOKEN: '0xfD055B11563b80648091d0F69704dD647714e134',
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    decimals: 18,
  },
} as const;
